import { render, staticRenderFns } from "./degreeSelect.vue?vue&type=template&id=8c53eacc&scoped=true&"
import script from "./degreeSelect.vue?vue&type=script&lang=js&"
export * from "./degreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./degreeSelect.vue?vue&type=style&index=0&id=8c53eacc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c53eacc",
  null
  
)

export default component.exports